import React from 'react';
import { Mail } from 'lucide-react';
import './Registry.css';

const Registry = () => {
    return (
        <section id="registry" className="section-container registry-section">
            <div className="registry-content">
                <Mail size={48} className="registry-icon" />
                <h2 className="section-title">Gifts & Red Envelopes</h2>
                <p className="registry-text">
                    Your presence at our wedding is the greatest gift we could ask for!
                    Please remember that gifts are absolutely not required.
                </p>
                <p className="registry-text">
                    Instead of a traditional registry, we are following the Chinese tradition of <a href="https://en.wikipedia.org/wiki/Red_envelope" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>red envelopes (hóngbāo)</a>.
                    If you would like to honor us with a gift, we kindly ask that it follow this tradition (though the envelope itself doesn't have to be red!).
                </p>
                <p className="registry-text">
                    If you cannot find a red envelope and would like to use one, we will have some available on the day of the wedding. Alternatively, if you'd prefer to give digitally, you can Venmo <strong>@swiftschwenk</strong> with a red envelope emoji (🧧).
                </p>
                <div className="registry-links">
                    <a href="https://venmo.com/swiftschwenk?txn=pay&note=🧧" target="_blank" rel="noopener noreferrer" className="btn red-envelope-btn">Venmo @swiftschwenk</a>
                </div>
            </div>
        </section>
    );
};

export default Registry;
